import EmailConfirm from 'apps/promo/components/email/EmailConfirm';
import Unsubscribe from 'apps/promo/components/email/Unsubscribe';
import { PROMO } from 'apps/promo/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/promo/constants/ServerConstants';

const noAuthWithJava = [
    {
        path: '/email/unsubscribe',
        component: Unsubscribe,
        view: AUTH_VIEW,
        isAuthZone: false,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
    {
        path: '/email/confirm/:code',
        component: EmailConfirm,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: false,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
];

export default noAuthWithJava;
